import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ChangeOrderTask.css';
import { Col, Form, FormGroup } from 'react-bootstrap';
import DatetimePicker from 'components/shared/datetime-picker/DatetimePicker';
import TextArea from 'components/shared/input/TextArea';
import ImageUpload from 'components/shared/image-upload/ImageUpload';
import Button from 'components/shared/button/Button';
import ChangeOrderQuoteRequestModal from 'components/admin/work-orders/details/change-order-quotes/ChangeOrderQuoteRequestModal';
import ChangeOrderQuoteConfirmationModal from 'components/admin/work-orders/details/change-order-quotes/ChangeOrderQuoteConfirmationModal';
import ChangeOrderQuoteSubmitModal from 'components/admin/work-orders/details/change-order-quotes/ChangeOrderQuoteSubmitModal';
import ChangeOrderTaskModal from 'components/admin/work-orders/details/change-order-tasks/ChangeOrderTaskModal';
import Number from 'components/shared/text/Number';

class ChangeOrderTask extends Component {
  static propTypes = {
    changeOrderTask: PropTypes.object,
    showEstimateInTitle: PropTypes.bool,
    showRequestQuoteBtn: PropTypes.bool,
    showSubmitQuoteBtn: PropTypes.bool,
    showDeleteCoBtn: PropTypes.bool,
    showWithdrawQuoteBtn: PropTypes.bool,
    showWithdrawCoQuoteRequestBtn: PropTypes.bool,
    onDeleteCoClick: PropTypes.func,
    onQuoteActionClick: PropTypes.func,
    onWithdrawQuoteClick: PropTypes.func,
    onWithdrawCoQuoteRequestClick: PropTypes.func,
    onEditActionClick: PropTypes.func,
  };

  renderImages = () => {
    let images = this.props.changeOrderTask.images.map(function (img) {
      return { id: img.id, url: img.image.url, preview: img.image.preview.url };
    });
    return images;
  };

  confirmationMsg = () => {
    if (this.props.showRequestQuoteBtn) {
      return 'Your change order pricing request has been sent.';
    } else {
      return 'Your change order pricing has been submitted.';
    }
  };

  renderTitle = () => {
    const coQuote = this.props.changeOrderTask.change_order_quote;
    let title = `Change Order #${this.props.changeOrderTask.number}`;

    if (this.props.showEstimateInTitle && coQuote && coQuote.estimate) {
      title = (
        <span>
          {title} - <Number value={coQuote.estimate} format="$0" />
        </span>
      );
    }

    return title;
  };

  render() {
    return (
      <div className="change-order-task">
        <div className="h3 title">{this.renderTitle()}</div>
        <Form horizontal>
          <FormGroup>
            <Col md={6}>
              <div className="form-item-label">Target Completion Date</div>
              <DatetimePicker
                className="completion-date"
                placeholder="Target Completion date"
                readOnly={true}
                value={this.props.changeOrderTask.completion_date}
                theme={'underlined'}
                onChange={() => {}}
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col md={12}>
              <div className="form-item-label">Description</div>
              <TextArea
                className="description"
                placeholder="Description"
                readOnly={true}
                value={this.props.changeOrderTask.description}
                theme={'underlined'}
                onChange={() => {}}
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col md={12}>
              <ImageUpload images={this.renderImages()} readOnly={true} />
            </Col>
          </FormGroup>
        </Form>
        {(this.props.showRequestQuoteBtn || this.props.showSubmitQuoteBtn) && (
          <React.Fragment>
            <Button
              className="button-orange change-order-pricing-btn"
              label="Change Order Pricing"
              onClick={this.props.onQuoteActionClick}
            />
            {this.props.showRequestQuoteBtn && (
              <Button
                className="button-gray change-order-pricing-btn"
                label="Edit Change Order"
                onClick={this.props.onEditActionClick}
              />
            )}

            {this.props.showDeleteCoBtn && (
              <Button
                className="button-white change-order-pricing-btn"
                label="Delete Change Order"
                onClick={this.props.onDeleteCoClick}
              />
            )}

            {this.props.showRequestQuoteBtn && (
              <div>
                <ChangeOrderTaskModal />
                <ChangeOrderQuoteRequestModal
                  changeOrderTask={this.props.changeOrderTask}
                />
              </div>
            )}

            {this.props.showSubmitQuoteBtn && (
              <ChangeOrderQuoteSubmitModal
                changeOrderTask={this.props.changeOrderTask}
              />
            )}
          </React.Fragment>
        )}

        {this.props.showWithdrawQuoteBtn && (
          <Button
            className="button-orange change-order-pricing-btn"
            label="Withdraw Change Order Pricing"
            onClick={this.props.onWithdrawQuoteClick}
          />
        )}

        {this.props.showWithdrawCoQuoteRequestBtn && (
          <Button
            className="button-orange change-order-pricing-btn"
            label="Withdraw Change Order Pricing request"
            onClick={this.props.onWithdrawCoQuoteRequestClick}
          />
        )}
        <ChangeOrderQuoteConfirmationModal message={this.confirmationMsg()} />
      </div>
    );
  }
}

export default ChangeOrderTask;



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/change-order-tasks/ChangeOrderTask.js